import Helpers from "@/Helpers.js";

export type ClientEnvironmentPayload = {
  language: string;
  languages: string;
  timeZone: string;
  localTime: string;
  platform: string;
  browser: string;
  os: string;
  screenWidth: number;
  screenHeight: number;
  colorDepth: number;
  pixelRatio: number;
  referrer: string;
  pageUrl: string;
  cookieEnabled: boolean;
  online: boolean;
  hardwareConcurrency: number;
  deviceMemory?: number;
  maxTouchPoints: number;
};

/** Collect browser-reported environment details for StartTest / QStart capture. */
export function collectClientEnvironment(): ClientEnvironmentPayload {
  const userAgentData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData || {};
  const platform = userAgentData.platform || navigator.platform || "";
  const { browser, os } = Helpers.getBrowserInfo();
  const languages = Array.isArray(navigator.languages)
    ? navigator.languages.filter(Boolean).join(",")
    : navigator.language || "";

  return {
    language: navigator.language || "",
    languages,
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    localTime: new Date().toISOString(),
    platform,
    browser,
    os,
    screenWidth: window.screen?.width || 0,
    screenHeight: window.screen?.height || 0,
    colorDepth: window.screen?.colorDepth || 0,
    pixelRatio: window.devicePixelRatio || 0,
    referrer: document.referrer || "",
    pageUrl: window.location.href || "",
    cookieEnabled: navigator.cookieEnabled,
    online: navigator.onLine,
    hardwareConcurrency: navigator.hardwareConcurrency || 0,
    deviceMemory: (navigator as Navigator & { deviceMemory?: number }).deviceMemory,
    maxTouchPoints: navigator.maxTouchPoints || 0,
  };
}
